import * as c from '@Criteria/Hierarchies/Domain/commands-core';
import { DiscreteScaleLevel } from '@Scales/Model';
import VueCqrs from '@cqrs/vue-component-cqrs';
import { Component } from 'vue-facing-decorator';

@Component
export default class CriteriaHierarchyCommands extends VueCqrs {

	invokeDeleteCriterionCommandV1(chId: number, criterionId: number, workspaceId: number)
	{
		const cmd = new c.DeleteCriterionCommandV1(chId, criterionId, workspaceId);
		this.$command(cmd, criterionId.toString());
	}

	invokeChangeCriterionParentCommandV1(chId: number, criterionId: number, parentId: number, workspaceId: number)
	{
		const cmd = new c.ChangeCriterionParentCommandV1(chId, criterionId, parentId, workspaceId);
		this.$command(cmd, criterionId.toString());
	}

	invokeUpdateCriterionCommandV1(chId: number, criterionId: number, name: string, desc: string, workspaceId: number)
	{
		const cmd = new c.UpdateCriterionCommandV1(chId, criterionId, name, desc, workspaceId);
		this.$command(cmd, criterionId.toString());
	}

	invokeCreateCriteriaFromStringCommandV1(chId: number, parentId: number, criteriaString: string, workspaceId: number)
	{
		const cmd = new c.CreateCriteriaFromStringCommandV1(chId, parentId, criteriaString, workspaceId);
		this.$command(cmd, parentId.toString());
	}


	invokeCreateCriterionCommandV1(chId: number, parentId: number, name: string, desc: string, workspaceId: number)
	{
		const cmd = new c.CreateCriterionCommandV1(chId, parentId, name, desc, workspaceId);
		this.$command(cmd, parentId.toString());
	}

	invokeCreateCriterionFromAttributeCommandV1(chId: number, parentId: number, attrId: number, name: string, workspaceId: number)
	{
		const cmd = new c.CreateCriterionFromAttributeCommandV1(chId, parentId, attrId, name, workspaceId);
		this.$command(cmd, parentId.toString());
	}

	invokeCreateCriterionFromTemplateCommandV1(chId: number, parentId: number, name: string, attrId: number, workspaceId: number)
	{
		const cmd = new c.CreateCriterionFromTemplateCommandV1(chId, parentId, name, attrId, workspaceId);
		this.$command(cmd, parentId.toString());
	}

	invokeAssignAttributeMeasurementCommandV1(workspaceId: number, chId: number, criterionId: number, attributeId: number)
	{
		const cmd = new c.AssignAttributeMeasurementCommandV1(workspaceId, chId, criterionId, attributeId);
		this.$command(cmd, `${criterionId}.${attributeId}`);
	}

	invokeAssignCustomScaleMeasurementCommandV1(workspaceId: number, chId: number, criterionId: number, scaleLevels: DiscreteScaleLevel[])
	{
		const cmd = new c.AssignCustomScaleMeasurementCommandV1(workspaceId, chId, criterionId, scaleLevels);
		this.$command(cmd, criterionId.toString());
	}

	invokeAssignPairwiseMeasurementCommandV1(workspaceId: number, chId: number, criterionId: number)
	{
		const cmd = new c.AssignPairwiseMeasurementCommandV1(workspaceId, chId, criterionId);
		this.$command(cmd, criterionId.toString());
	}

	invokeAssignScaleTemplateMeasurementCommandV1(workspaceId: number, chId: number, criterionId: number, scaleTemplateId: number)
	{
		const cmd = new c.AssignScaleTemplateMeasurementCommandV1(workspaceId, chId, criterionId, scaleTemplateId);
		this.$command(cmd, criterionId.toString());
	}

	invokeUpdateCriterionMeasurementCommandV1(wsId: number, chId: number, criterionId: number, attrId: number, maxValue: number)
	{
		const cmd = new c.UpdateCriterionMeasurementCommandV1(wsId, chId, criterionId, attrId, maxValue);
		this.$command(cmd, criterionId.toString());
	}

	invokeChangeDefaultWeightsSetCommandV1(workspaceId: number, chId: number, oldDefaultId: number, newDefaultId: number)
	{
		if (oldDefaultId !== newDefaultId)
		{
			const cmd = new c.ChangeDefaultWeightsSetCommandV1(workspaceId, chId, oldDefaultId, newDefaultId);
			this.$command(cmd, newDefaultId.toString());
		}
	}
}
